import TextareaMessageTo from "../inputs/TextareaMessageTo";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import {GreenButton} from "../buttons/ButtonStyles";
import ExitButton from "../buttons/ExitButton";
import {useDispatch, useSelector} from "react-redux";
import {callSbAgain} from "../dashboard/dashBoardAction";
import {displayAlert} from "../../utils/utils";
import {CLEAR_MESSAGE} from "../message/actions/actionTypes";
import SendMessageLoader from "../progress-bar/SendMessageLoader";

const CallSbAgainModal = ({
                              handleModalStatus,
                              selectedItemIds,
                              setMultipleSelectionProjectIds, setIsChecked
                          }) => {


    const {isPending, status} = useSelector(state => state.message)
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            setMultipleSelectionProjectIds([])
            setIsChecked(false)
            dispatch({type: CLEAR_MESSAGE})
            clearInterval()
        }
    }, [dispatch, setIsChecked, setMultipleSelectionProjectIds])

    const [selectedOption, setSelectedOption] = useState("")

    const handleChange = (e) => {
        setSelectedOption(e.target.value)
    }
    const handleModalOpening = () => {
        handleModalStatus(false)
    }

    const handleSubmit = async () => {
        let data = {}
        data.projectsIds = []
        if (selectedOption.trim() !== "") {
            data.message = selectedOption
        }
        if (selectedItemIds[0].length > 1) {
            selectedItemIds[0].forEach((i) => {
                data.projectsIds.push(i)
            })
        } else {

            const projectId = Number(selectedItemIds[0].toString())
            data.projectsIds.push(projectId)
        }

        await dispatch(callSbAgain(data))
        handleModalStatus(false)
    }

    return (
        <div className={"shadow"}>

            {displayAlert(status !== 0 && (status.toString().startsWith("4") || status.toString().startsWith("5")), status.toString().startsWith("2"))}

            <Modal>
                <div>
                    <FirstSection>
                        <h1> Relancer
                            le{selectedItemIds[0]?.length > 1 ? "s" : ""} projet{selectedItemIds[0]?.length > 1 ? "s" : ""} sélectionné{selectedItemIds[0]?.length > 1 ? "s" : ""} </h1>
                        <ExitButton
                            closeUpdate={handleModalOpening}
                        />
                    </FirstSection>
                    <p> En faisant cette action, un mail sera envoyé
                        au{selectedItemIds.length > 1 ? "x" : ""} pilote{selectedItemIds.length > 1 ? "s" : ""} afin
                        qu'il{selectedItemIds.length > 1 ? "s" : ""} mette{selectedItemIds.length > 1 ? "nt" : ""} à
                        jour {selectedItemIds.length > 1 ? "leur" : "son"} projet </p>
                </div>
                <div>
                    <label> Message </label>
                    <TextareaMessageTo
                        selectedOption={selectedOption}
                        handleChange={handleChange}
                        name={"message"}
                        placeholder={"Envoyer un message (facultatif)"}
                    />
                </div>
                {isPending &&
                <SendMessageLoader/>
                }
                <Button onClick={!isPending ? handleSubmit : null}>
                    <p> Relancer </p>
                </Button>
            </Modal>
        </div>
    )
}

const Modal = styled(BaseModal)`
  gap: 3em;
  align-items: center;
  height: fit-content;


  div:not(div:first-child) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  textarea {
    width: 100%;
    height: 10em;
  }

  @media (min-width: 600px) {
    width: 550px;
  }
`
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;

  h1 {
    text-align: center;
    flex-grow: 1;
  }
`
const Button = styled(GreenButton)`
  width: 10rem;
`

export default CallSbAgainModal;